var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.componentId
    ? _c(
        _setup.Button,
        {
          staticClass: "btn-sm",
          nativeOn: {
            click: function ($event) {
              return _setup.openFieldsModal.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n    Fields\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }